module.exports = __webpack_public_path__ + "img/shifts.31fd2fbd.svg";